import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faCheckDouble } from "@fortawesome/free-solid-svg-icons/faCheckDouble";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons/faCircleExclamation";
import { SizeProp } from "@fortawesome/fontawesome-svg-core";

import { AtiraIcon } from "../../../../../components/AtiraIcon";
import { ConversationMessage } from "../../../../../model/integration/dto/meta/MetaConversationMessage";
import { ThemeType } from "../../../../../theme/Theme";

type Props = {
  status?: ConversationMessage["status"];
  color?: keyof ThemeType;
  size?: SizeProp;
};

export const WAMessageTicks: React.FC<Props> = ({
  status,
  color = "darkerSub",
  size = "xs",
}) => {
  if (status === "read") {
    return <AtiraIcon icon={faCheckDouble} color="lightAccent" size={size} />;
  }

  if (status === "delivered") {
    return <AtiraIcon icon={faCheckDouble} color={color} size={size} />;
  }

  if (status === "queued" || status === "sent") {
    return <AtiraIcon icon={faCheck} color={color} size={size} />;
  }

  if (status === "failed") {
    return <AtiraIcon icon={faCircleExclamation} color="danger" size={size} />;
  }

  return null;
};
